import type { RouteRecordRaw } from 'vue-router';

export const homeRoute: RouteRecordRaw = {
  path: '/',
  name: 'Home',
  component: () => import('./pages/HomePage.vue'),
  meta: {
    depth: 0,
  },
};
